var map = {
	"./admited.png": 4556,
	"./alternate.png": 77222,
	"./awaitAdmit.png": 91852,
	"./awaitReview.png": 21354,
	"./completed.png": 98714,
	"./enrolled.png": 44489,
	"./notAdmit.png": 40874,
	"./reviewAdopt.png": 88654,
	"./reviewNot (1).png": 73310,
	"./reviewNot.png": 69974,
	"./代报名.png": 61050,
	"./立即报名-初始.png": 98418,
	"./立即报名-禁用.png": 17044,
	"./立即报名-经过.png": 73592
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 79993;